import isFinite from 'lodash/isFinite';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class NumberApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: [{ int: parseFloat(String(value)), bool: true, comment }],
            comment,
        };
    }

    public validate({ params: { maxLength, minLength, required }, responseActor }: QuestionContext): boolean {
        const reponse = responseActor.getSnapshot().context;
        const value = parseInt(`${reponse.value}`);

        if (!required) return true;

        if (typeof minLength === 'number' && value < minLength) {
            return false;
        }

        if (typeof maxLength === 'number' && value > maxLength) {
            return false;
        }

        return isFinite(value);
    }
}
